<div class="col-sm-12 padding-right-0 padding-left-0 mr-20">
  <div class="hpanel margin-bottom-5">
    <div class="panel-heading hbuilt" style="border-bottom: 1 important;">
      <label class="control-label padding-top-0 margin-bottom-5 margin-top-5 f-16 ">Access to Applications</label>
    </div>

    <div>
      <app-common-skeleton *ngIf="loadAPIcall" [countforView]="11"
      [NameOftheScreen]="'notification'"></app-common-skeleton>
    </div>

    <div *ngIf="!loadAPIcall">

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4>  -->
            <span class="m-r-15">
              <!-- <ng-icon name="tablerBriefcase" style="font-size: 15px;"></ng-icon> -->
              <svg width="20px" height="20px" viewBox="0 0 1024 1024"  >
                <path fill="#000000"
                  d="M128 384h768v-64a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64v64zm0 64v320a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V448H128zm64-256h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128z" />
                <path fill="#000000"
                  d="M384 128v64h256v-64H384zm0-64h256a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64H384a64 64 0 0 1-64-64v-64a64 64 0 0 1 64-64z" />
              </svg>
            </span>
           <span> Jobs</span>
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4> -->
            <span class="m-r-15">
              <!-- <ng-icon name="tablerUsers" style="font-size: 15px;"></ng-icon>  -->
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"  >
                <path
                  d="M18 19V18C18 15.7909 16.2091 14 14 14H10C7.79086 14 6 15.7909 6 18V19M23 19V18C23 15.7909 21.2091 14 19 14H18.5M1 19V18C1 15.7909 2.79086 14 5 14H5.5M17 11C18.6569 11 20 9.65685 20 8C20 6.34315 18.6569 5 17 5M7 11C5.34315 11 4 9.65685 4 8C4 6.34315 5.34315 5 7 5M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z"
                  stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span> Candidates
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4> -->
            <span class="m-r-15">
              <!-- <img src="assets/master_menu/team.svg" style="width: 20px;">  -->
              <svg fill="#000000" width="20px" height="20px" viewBox="0 0 256 256" id="Layer_1" version="1.1"
                xml:space="preserve"   xmlns:xlink="http://www.w3.org/1999/xlink">
                <g>
                  <path
                    d="M184.4,48.5L184.4,48.5c1.9,9.7,10.4,16.8,20.3,16.8c9.9,0,18.4-7.1,20.3-16.8l2.5-12.7c0.8-6.2-1-12.4-5.1-17.1   s-10-7.4-16.2-7.4h-2.9c-6.2,0-12.1,2.7-16.2,7.4s-6,10.9-5.1,17.4L184.4,48.5z M194.6,25.3c2.2-2.5,5.4-4,8.8-4h2.9   c3.4,0,6.5,1.4,8.8,4c2.2,2.5,3.2,5.9,2.8,8.9l-2.4,12.4c-1,5.1-5.4,8.7-10.6,8.7s-9.6-3.7-10.6-8.7l-2.4-12.1   C191.4,31.2,192.4,27.8,194.6,25.3z" />
                  <path
                    d="M251.3,114.4l-5.7-27c-0.7-3.3-3.1-6-6.2-7.1l-19.7-7l-14.8,14.8l-14.8-14.8l-19.7,7c-3.1,1.1-5.5,3.8-6.2,7.1l-5.7,27   c-0.6,2.7,1.1,5.3,3.8,5.9c2.7,0.6,5.3-1.1,5.9-3.8l5.6-26.8l13.8-4.9l17.4,17.4l17.4-17.4l13.6,4.7l5.7,27   c0.5,2.3,2.6,3.9,4.9,3.9c0.3,0,0.7,0,1-0.1C250.1,119.8,251.8,117.1,251.3,114.4z" />
                  <path
                    d="M30.9,48.5L30.9,48.5c1.9,9.7,10.4,16.8,20.3,16.8c9.9,0,18.4-7.1,20.3-16.8L74,35.8c0.8-6.2-1-12.4-5.1-17.1   s-10-7.4-16.2-7.4h-2.9c-6.2,0-12.1,2.7-16.2,7.4s-6,10.9-5.1,17.4L30.9,48.5z M41.1,25.3c2.2-2.5,5.4-4,8.8-4h2.9   c3.4,0,6.5,1.4,8.8,4c2.2,2.5,3.2,5.9,2.8,8.9l-2.4,12.4c-1,5.1-5.4,8.7-10.6,8.7s-9.6-3.7-10.6-8.7l-2.4-12.1   C37.8,31.2,38.9,27.8,41.1,25.3z" />
                  <path
                    d="M68.7,84.8l13.6,4.7l5.7,27c0.5,2.3,2.6,3.9,4.9,3.9c0.3,0,0.7,0,1-0.1c2.7-0.6,4.4-3.2,3.8-5.9l-5.7-27   c-0.7-3.3-3.1-6-6.2-7.1l-19.7-7L51.2,88.2L36.4,73.3l-19.7,7c-3.1,1.1-5.5,3.8-6.2,7.1l-5.7,27c-0.6,2.7,1.1,5.3,3.8,5.9   c2.7,0.6,5.3-1.1,5.9-3.8L20,89.7l13.8-4.9l17.4,17.4L68.7,84.8z" />
                  <path
                    d="M128,189.5c9.9,0,18.4-7.1,20.3-16.8l2.5-12.7c0.8-6.2-1-12.4-5.1-17.1c-4.1-4.7-10-7.4-16.2-7.4h-2.9   c-6.2,0-12.1,2.7-16.2,7.4c-4.1,4.7-6,10.9-5.1,17.4l2.4,12.4v0C109.6,182.4,118.1,189.5,128,189.5z M117.8,149.5   c2.2-2.5,5.4-4,8.8-4h2.9c3.4,0,6.5,1.4,8.8,4c2.2,2.5,3.2,5.9,2.8,8.9l-2.4,12.4c-1,5.1-5.4,8.7-10.6,8.7s-9.6-3.7-10.6-8.7   l-2.4-12.1C114.6,155.4,115.6,152,117.8,149.5z" />
                  <path
                    d="M168.8,211.7c-0.7-3.3-3.1-6-6.2-7.1l-19.7-7L128,212.4l-14.8-14.8l-19.7,7c-3.1,1.1-5.5,3.8-6.2,7.1l-5.7,27   c-0.6,2.7,1.1,5.3,3.8,5.9c2.7,0.6,5.3-1.1,5.9-3.8l5.5-26.8l13.8-4.9l17.4,17.4l17.4-17.4l13.6,4.7l5.7,27   c0.5,2.3,2.6,3.9,4.9,3.9c0.3,0,0.7,0,1-0.1c2.7-0.6,4.4-3.2,3.8-5.9L168.8,211.7z" />
                  <path
                    d="M213.4,133.5c-2.8-0.3-5.2,1.7-5.4,4.5c-2,20.7-11.9,39.5-27.7,53c-2.1,1.8-2.3,4.9-0.6,7c1,1.2,2.4,1.7,3.8,1.7   c1.1,0,2.3-0.4,3.2-1.2c17.8-15.2,28.9-36.3,31.2-59.6C218.1,136.2,216.1,133.8,213.4,133.5z" />
                  <path
                    d="M48.1,138c-0.3-2.7-2.7-4.7-5.4-4.5c-2.7,0.3-4.7,2.7-4.5,5.4c2.3,23.3,13.4,44.5,31.2,59.6c0.9,0.8,2.1,1.2,3.2,1.2   c1.4,0,2.8-0.6,3.8-1.8c1.8-2.1,1.5-5.2-0.6-7C60,177.5,50.1,158.7,48.1,138z" />
                  <path
                    d="M101.7,54.1c16.7-5.9,35.9-5.9,52.7,0c0.5,0.2,1.1,0.3,1.7,0.3c2,0,4-1.3,4.7-3.3c0.9-2.6-0.4-5.4-3-6.3   c-18.9-6.7-40.4-6.7-59.3,0c-2.6,0.9-3.9,3.8-3,6.3C96.2,53.7,99.1,55,101.7,54.1z" />
                </g>
              </svg>
            </span>
            Workspace
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4> -->
            <span class="m-r-15">
              <!-- <ng-icon name="tablerMessage"></ng-icon>  -->
              <svg width="20px" height="20px" viewBox="0 0 1024 1024" class="icon" version="1.1"
                 >
                <path
                  d="M780.7 582.4V286.3c0-74.2-60.7-134.9-134.9-134.9H198.2c-74.2 0-134.9 60.7-134.9 134.9v296.1c0 70.5 54.8 128.7 123.8 134.4 0 0-20 155.4 4.9 155.4s188.4-154.9 188.4-154.9h265.3c74.3 0 135-60.7 135-134.9z m-424.1 74.9l-17.4 16.4c-0.3 0.3-34.5 32.7-73.2 67.1-8.5 7.5-16.2 14.3-23.3 20.5 1.9-20.9 3.9-36.6 3.9-36.8l8-62.3L192 657c-38.5-3.2-68.7-36-68.7-74.6V286.3c0-19.9 7.8-38.6 22.1-52.8 14.2-14.2 33-22.1 52.8-22.1h447.6c19.9 0 38.6 7.8 52.8 22.1 14.2 14.2 22.1 33 22.1 52.8v296.1c0 19.9-7.8 38.6-22.1 52.8-14.2 14.2-33 22.1-52.8 22.1H356.6z" />
                <path
                  d="M830.3 337.9c-16.2-3.3-32.1 7.1-35.4 23.3-3.3 16.2 7.1 32.1 23.3 35.4 39 8 67.3 42.7 67.3 82.5v177c0 41.6-31.1 77.5-72.3 83.4l-32.7 4.7 7.8 32.1c2 8.1 3.9 16.8 5.8 25.3-17.6-16.4-37.3-35.2-55.2-52.7l-8.7-8.6H562.5c-21.9 0-36.6-1.4-47.2-8.6-13.7-9.3-32.4-5.8-41.7 7.9-9.3 13.7-5.8 32.4 7.9 41.7 25.7 17.5 55.3 19 81 19h143.2c10 9.7 27.3 26.3 45 42.8 16.2 15.1 29.6 27.1 39.8 35.9 20 17 29.3 23.1 41.6 23.1 9.7 0 18.7-4.4 24.8-12.1 10.1-12.9 10.2-29.1 0.5-78.7-1.4-7.2-2.9-14.2-4.3-20.6 54.4-21.1 92.4-74.3 92.4-134.6v-177c0.1-68-48.4-127.4-115.2-141.2z" />
              </svg>
            </span> Chat
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4> -->
            <span class="m-r-15">
              <!-- <img src="assets/master_menu/connect-people.svg" style="width: 20px;">  -->
              <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g fill="none" fill-rule="evenodd" id="gig01" stroke="none" stroke-width="1">
                  <g id="gig02" stroke="#212121" stroke-width="1.5" transform="translate(-175.000000, -142.000000)">
                    <g id="gig03" transform="translate(175.000000, 142.000000)">
                      <g id="gig04" transform="translate(4.000000, 3.000000)">
                        <path
                          d="M14.5,6 C13.1193,6 12,4.8807 12,3.5 C12,2.11929 13.1193,1 14.5,1 C15.8807,1 17,2.11929 17,3.5 C17,4.8807 15.8807,6 14.5,6 Z"
                          id="gig05" />
                        <path
                          d="M2,4 C0.89543,4 0,3.10455 0,2 C0,0.89543 0.89543,0 2,0 C3.10455,0 4,0.89543 4,2 C4,3.10455 3.10455,4 2,4 Z"
                          id="gig06" />
                        <path
                          d="M9,17.5 L12,15 L12,12 C12,10.26695 13,9 14.5,9 C16,9 17,10.26695 17,12 L17,14.4186 L17,19"
                          id="gig07" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8,14.5 L5,12 L5,10 C5,8.26695 4,7 2.5,7 C1,7 0,8.26695 0,10 L0,11.4186 L0,19"
                          id="gig08" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            Connections
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4>  -->
            <span class="m-r-15">
              <!-- <img src="assets/master_menu/my-network.svg" style="width: 20px;">  --><svg width="20px" height="20px" viewBox="0 0 32 32" data-name="Layer 1" id="Layer_1" >
            <path class="cls-1" d="M9.28,25h0A5,5,0,0,0,10,22a3.16,3.16,0,0,0-3-3,3.16,3.16,0,0,0-3,3,5,5,0,0,0,.74,3h0c-.36.1-2.72,1.2-2.72,3a1,1,0,0,0,2,0c0-.28.89-.88,1.28-1l.11,0a2.35,2.35,0,0,0,1.1-.57,2.63,2.63,0,0,0,1,0,2.35,2.35,0,0,0,1.1.57l.07,0c.43.16,1.28.77,1.32,1.05a1,1,0,0,0,2,0C12,26.24,9.64,25.14,9.28,25ZM7,21a1.17,1.17,0,0,1,1,1,2.68,2.68,0,0,1-.71,2.29h0a.35.35,0,0,1-.58,0A2.68,2.68,0,0,1,6,22,1.17,1.17,0,0,1,7,21Z"/><path class="cls-1" d="M27.28,25h0A5,5,0,0,0,28,22a3.16,3.16,0,0,0-3-3,3.16,3.16,0,0,0-3,3,5,5,0,0,0,.74,3h0c-.36.1-2.72,1.2-2.72,3a1,1,0,0,0,2,0c0-.28.89-.88,1.28-1l.11,0a2.35,2.35,0,0,0,1.1-.57,2.63,2.63,0,0,0,1,0,2.35,2.35,0,0,0,1.1.57l.07,0c.43.16,1.28.77,1.32,1.05a1,1,0,0,0,2,0C30,26.24,27.64,25.14,27.28,25ZM25,21a1.17,1.17,0,0,1,1,1,2.68,2.68,0,0,1-.71,2.29h0a.35.35,0,0,1-.58,0A2.68,2.68,0,0,1,24,22,1.17,1.17,0,0,1,25,21Z"/><path class="cls-1" d="M12,13a1,1,0,0,0,1-1c0-.28.89-.89,1.28-1l.11,0a2.3,2.3,0,0,0,1.1-.58,2.2,2.2,0,0,0,1,0,2.3,2.3,0,0,0,1.1.58l.07,0c.43.16,1.28.77,1.32,1.05a1,1,0,0,0,2,0c0-1.77-2.36-2.86-2.72-3h0A5,5,0,0,0,19,6a3.16,3.16,0,0,0-3-3,3.16,3.16,0,0,0-3,3,5,5,0,0,0,.74,3h0c-.36.1-2.72,1.19-2.72,3A1,1,0,0,0,12,13Zm4-8a1.17,1.17,0,0,1,1,1,2.68,2.68,0,0,1-.71,2.29.41.41,0,0,1-.58,0A2.68,2.68,0,0,1,15,6,1.17,1.17,0,0,1,16,5Z"/><path class="cls-1" d="M20.6,20.2,17,17.5V14a1,1,0,0,0-2,0v3.5l-3.6,2.7a1,1,0,0,0-.2,1.4,1,1,0,0,0,.8.4,1,1,0,0,0,.6-.2L16,19.25l3.4,2.55a1,1,0,0,0,.6.2,1,1,0,0,0,.8-.4A1,1,0,0,0,20.6,20.2Z"/></svg>
            </span> Network
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4>  -->
            <span class="m-r-15">
              <!-- <img src="assets/master_menu/community.svg" style="width: 20px;">  -->
              <svg version="1.1" id="Layer_1"   xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px" y="0px" height="20px" width="20px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
              <g>
                <path class="st0" d="M35.3,12.2L50,33.3l14.8-21.4c2.4-3.5-4.1-5.5-7,0C54.6,18,46,18.2,42.4,12.4C38.5,6.1,33,9,35.3,12.2
                  L35.3,12.2z" />
                <path class="st0"
                  d="M84.7,84.6c2.6-2.6,2.6-6.7,0-9.2c-2.6-2.6-6.7-2.6-9.2,0c-2.6,2.6-2.6,6.7,0,9.2C77.9,87,82.1,87,84.7,84.6z" />
                <path class="st0" d="M66.3,13l-4.6,25.4l25.7-4.6c4.3-0.8,1.2-6.9-4.9-5c-6.6,2-12.8-4-11.1-10.7C72.9,11.1,67.1,9,66.3,13L66.3,13
                  z" />
                <path class="st0" d="M88.2,57.9c-6.1-3.2-6.3-11.9-0.5-15.4c6.1-3.7,3.2-9.3,0-7L66.6,50.1L88,64.9C91.7,67.3,93.7,60.8,88.2,57.9
                  L88.2,57.9z" />
                <path class="st0"
                  d="M50.2,66.7L35.3,88.1c-2.4,3.7,4,5.7,7,0.2c3.2-6.1,11.9-6.3,15.4-0.5c3.7,6.1,9.3,3.2,7,0L50.2,66.7z" />
                <path class="st0" d="M87.1,66.4l-25.4-4.6l4.6,25.7c0.8,4.3,6.9,1.2,5-4.9c-2-6.6,4-12.8,10.7-11.1C89.1,73.1,90.9,67,87.1,66.4
                  L87.1,66.4z" />
                <path class="st0"
                  d="M56.6,92.4c0-3.7-2.9-6.6-6.6-6.6s-6.6,2.9-6.6,6.6c0,3.7,2.9,6.6,6.6,6.6S56.6,96,56.6,92.4z" />
                <path class="st0" d="M98.9,49.9c0,3.6-2.9,6.6-6.6,6.6c-3.6,0-6.6-2.9-6.6-6.6c0-3.6,2.9-6.6,6.6-6.6
                  C95.9,43.4,98.9,46.3,98.9,49.9" />
                <path class="st0" d="M24.6,84.7c2.6-2.6,2.6-6.7,0-9.2c-2.6-2.6-6.7-2.6-9.2,0c-2.6,2.6-2.6,6.7,0,9.2
                  C18.1,87.2,22.2,87.2,24.6,84.7z" />
                <path class="st0" d="M24.6,24.7c2.6-2.6,2.6-6.7,0-9.2c-2.6-2.6-6.7-2.6-9.2,0c-2.6,2.6-2.6,6.7,0,9.2
                  C17.9,27.3,22.1,27.3,24.6,24.7z" />
                <path class="st0"
                  d="M7.7,56.6c3.7,0,6.6-2.9,6.6-6.6s-2.9-6.6-6.6-6.6c-3.5,0-6.6,2.9-6.6,6.6S4,56.6,7.7,56.6z" />
                <path class="st0" d="M12.3,57.7c-6.1,3.7-3.2,9.3,0,7l21.1-14.7L12,35.3c-3.7-2.4-5.7,4.1-0.2,7C17.9,45.6,18.1,54.2,12.3,57.7
                  L12.3,57.7z" />
                <path class="st0" d="M17.5,71.6c6.6-2,12.8,4,11.1,10.7c-1.7,7,4.3,8.9,4.9,5L38.1,62l-25.7,4.6C8.3,67.3,11.5,73.4,17.5,71.6
                  L17.5,71.6z" />
                <path class="st0" d="M12.9,33.7l25.4,4.6l-4.6-25.7c-0.8-4.3-6.9-1.2-5,4.9c2,6.6-4,12.8-10.7,11.1C10.9,27,9.1,33.1,12.9,33.7
                  L12.9,33.7z" />
                <path class="st0" d="M84.5,24.7c2.6-2.6,2.6-6.7,0-9.2c-2.6-2.6-6.7-2.6-9.2,0c-2.6,2.6-2.6,6.7,0,9.2
                  C77.8,27.2,81.9,27.2,84.5,24.7z" />
                <path class="st0"
                  d="M49.8,14.2c3.7,0,6.6-2.9,6.6-6.6s-2.9-6.6-6.6-6.6S43.3,4,43.3,7.6C43.4,11.3,46.3,14.2,49.8,14.2z" />
              </g>
            </svg>
            </span>
            Communities
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4>  -->
            <span class="m-r-15">
              <!-- <ng-icon name="tablerBuilding" style="font-size: 18px; color: #6d6e70; "></ng-icon> -->
              <svg fill="#000000" width="20px" height="20px" viewBox="0 0 50 50"   xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M9 0C7.355469 0 6 1.355469 6 3L6 50L44 50L44 3C44 1.355469 42.644531 0 41 0 Z M 9 2L41 2C41.554688 2 42 2.445313 42 3L42 48L38 48L38 36L27 36L27 48L8 48L8 3C8 2.445313 8.445313 2 9 2 Z M 12 6L12 14L23 14L23 6 Z M 27 6L27 14L38 14L38 6 Z M 14 8L21 8L21 12L14 12 Z M 29 8L36 8L36 12L29 12 Z M 12 16L12 24L23 24L23 16 Z M 27 16L27 24L38 24L38 16 Z M 14 18L21 18L21 22L14 22 Z M 29 18L36 18L36 22L29 22 Z M 12 26L12 34L23 34L23 26 Z M 27 26L27 34L38 34L38 26 Z M 14 28L21 28L21 32L14 32 Z M 29 28L36 28L36 32L29 32 Z M 12 36L12 44L23 44L23 36 Z M 14 38L21 38L21 42L14 42 Z M 29 38L36 38L36 48L29 48Z"/></svg>
            </span> Business
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4>  -->
            <span class="m-r-15">
              <!-- <ng-icon name="tablerFileDescription" style="font-size: 15px;"></ng-icon>  -->
              <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" id="contract-right" data-name="Flat Line"   class="icon flat-line">
                <path id="primary" d="M17,13v7a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3H16a1,1,0,0,1,1,1V7" style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></path>
                <path id="primary-2" data-name="primary" d="M20.71,9.09,15.8,14H13V11.2l4.91-4.91a1,1,0,0,1,1.4,0l1.4,1.4A1,1,0,0,1,20.71,9.09ZM7,17h3" style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></path>
              </svg>
            </span> Contracts
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4>  -->
            <span class="m-r-15">
              <ng-icon name="tablerFileDescription" class="gs-icon-action"></ng-icon>
            </span> eSign
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>

      <div class="col-sm-12 panel-body p-0 flex-align-center app-access-items">
        <div class="col-sm-9 flex-align-center">
          <!-- <h4>  -->
            <span class="m-r-15">
              <ng-icon name="tablerFileInvoice" class="gs-icon-action"></ng-icon>
            </span> Invoice
          <!-- </h4> -->
        </div>
        <label id="button" class="switch">
          <input type="checkbox" class="checkbox">
          <span class="slider round1"></span>
        </label>
      </div>
    </div>

  </div>
</div>
